import { FormField, NumberInput } from '@wix/design-system';
import t__default, { useRef } from 'react';

const InputWithLabel = ({ label, value, onChange, min, max, dataHook }) => {
  const inputRef = useRef(null);
  const handleInputWithinBounds = (data) => {
    const numberValue = typeof data === "string" && data.trim() !== "" && !isNaN(Number(data)) ? parseFloat(parseFloat(data).toFixed(2)) : NaN;
    const valueWithinBounds = (isNaN(numberValue) || numberValue < min ? min : numberValue > max ? max : numberValue).toString();
    if (value !== valueWithinBounds) {
      onChange(valueWithinBounds);
      return;
    }
  };
  return /* @__PURE__ */ t__default.createElement(
    FormField,
    {
      label,
      labelSize: "small",
      labelPlacement: "left",
      labelWidth: "60%",
      inputWidth: "40%"
    },
    /* @__PURE__ */ t__default.createElement(
      NumberInput,
      {
        inputRef,
        value,
        onChange: (_, stringValue) => {
          onChange(stringValue);
        },
        min,
        max,
        onBlur: (e) => {
          handleInputWithinBounds(e.target.value);
        },
        onKeyDown: (e) => {
          var _a;
          if (e.key === "Enter") {
            handleInputWithinBounds((_a = inputRef.current) == null ? void 0 : _a.value);
          }
        },
        size: "small",
        dataHook
      }
    )
  );
};

export { InputWithLabel };
//# sourceMappingURL=input-with-label.js.map
